import { useAtomValue } from 'jotai'

import { Modal } from '@sequencehq/core-components'

import { AvalaraBlocker } from 'Integrations/index'
import { UseTaxModals, useTaxModals } from 'common/hooks/tax'
import { clientInvoiceAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { TaxRatesModalUI } from 'SettingsV2/components/tax-rates/modals/TaxRatesModal'

export const useClientInvoiceTaxModals = ({
  taxCategoryId
}: {
  taxCategoryId: string
}) => {
  const clientInvoice = useAtomValue(clientInvoiceAtom)

  return useTaxModals({
    customerCountry: clientInvoice?.customerBillingAddress?.country,
    customerState: clientInvoice?.customerBillingAddress?.state,
    customerTaxStatus: clientInvoice?.customerTaxStatus ?? 'TAXED',
    taxCategoryId
  })
}

export const TaxRateModals = ({
  hook: { modals }
}: {
  hook: ReturnType<UseTaxModals>
}) => (
  <>
    <Modal
      isOpen={modals.sequence.active}
      onClose={modals.sequence.onClose}
      data-testid="invoice.taxRatesModal"
    >
      <TaxRatesModalUI
        onSubmit={modals.sequence.onConfirm}
        countriesWithTaxRates={modals.sequence.data?.countryTaxRates}
        taxCategories={modals.sequence.data?.taxCategories}
        preselectedCountry={modals.sequence.data?.customerCountry}
        preselectedState={modals.sequence.data?.customerState}
        options={{
          closeOnCancel: false,
          closeOnSubmit: false,
          submitText: 'Save tax rates',
          onCancel: modals.sequence.onClose,
          onClose: modals.sequence.onClose
        }}
        onClose={modals.sequence.onClose}
      />
    </Modal>

    <AvalaraBlocker
      isOpen={modals.avalara.active}
      confirmTitleText="Update line item"
      onClose={modals.avalara.onClose}
    >
      This line item's tax category needs to be mapped to an Avalara tax code.
    </AvalaraBlocker>
  </>
)
